import React from "react";

export default function WelcomeMessage() {
	return (
		<div className="flex flex-col gap-1.5">
			<div className="text-[11px] font-semibold uppercase tracking-[0.3em] text-emerald-700 dark:text-emerald-300">
				Track Your Impact
			</div>
			<h1 className="text-[1.9rem] font-semibold leading-none text-gray-900 dark:text-gray-100 sm:text-[2.15rem]">
				Sign in
			</h1>
			<p className="text-sm text-gray-600 dark:text-gray-300">
				Use your admin credentials to continue.
			</p>
		</div>
	);
}
